// Single source of truth for accepted ID document types: sides, camera aspect, label key, and band.
export const ID_DOCUMENT_TYPES = {
	id: { labelKey: 'nationalIdLabel', sides: 2, aspect: 'id-1' },
	passport: { labelKey: 'passportLabel', sides: 1, aspect: 'passport' },
	// Residence permit is also an ID-1 card, so it's disambiguated from National ID by the MiniDoc band.
	'residence-permit': { labelKey: 'residencePermitLabel', sides: 2, aspect: 'id-1', band: true },
	// Not offered yet: `driving` is still on the legacy blink-id parser; kept here so it's ready to enable.
	driving: { labelKey: 'driversLicenseLabel', sides: 2, aspect: 'id-1' },
};

export const SIDE_COUNT = Object.fromEntries(
	Object.entries(ID_DOCUMENT_TYPES).map(([type, meta]) => [type, meta.sides]),
);

export const sidesForType = (type) => (SIDE_COUNT[type] === 1 ? ['single'] : ['front', 'back']);

// The MiniDoc draws a booklet for passports and a landscape card for everything else.
export const miniDocVariant = (type) => (ID_DOCUMENT_TYPES[type]?.aspect === 'passport' ? 'booklet' : 'card');
